import { useNavigate } from "react-router-dom";
import { appFeature } from "../../../app.feature";
import { getVisibleMenu } from "@core/utility/menu-visibility";
import { useUserIdentityContext } from "@core/services/user-identity.context";
import { useCallback } from "react";

export function useEditPersonMenu() {
  const navigate = useNavigate();
  const { hasAccess } = useUserIdentityContext();

  const getScheduleChildItems = useCallback(() => {
    const childItems = [];

    if (hasAccess("employee-schedule-shift")) {
      childItems.push({
        label: "Shift",
        value: "shift",
        payload: "shift",
        command: () => navigate("shift"),
      });
    }
    if (hasAccess("employee-schedule-dtr")) {
      childItems.push({
        label: "DTR",
        value: "daily-time-record",
        payload: "daily-time-record",
        command: () => navigate("daily-time-record"),
      });
    }
    if (hasAccess("employee-schedule-leave-ledger")) {
      childItems.push({
        label: "Leave Ledger",
        value: "ledger",
        payload: "ledger",
        command: () => navigate("ledger"),
      });
    }
    if (hasAccess("employee-schedule-branch-transfer")) {
      childItems.push({
        label: "Branch Transfer",
        value: "transfer",
        payload: "transfer",
        command: () => navigate("transfer"),
      });
    }

    return childItems;
  }, [hasAccess, navigate]);


  const getMenu = useCallback(() => {
    let menu = [] as any[];

    if (hasAccess("employee-schedule-request")) {
      const requestmenu = {
        label: 'Requests',
        items: [],
        command: () => navigate(""),
      }
      // insert requestmenu to first index of menu
      menu.push(requestmenu)
    }

    const otherMenu = [
      {
        label: "Employment",
        items: [
          {
            label: "General",
            value: "general",
            payload: "general",
            command: () => navigate("general"),
          },
          {
            label: "Attachment",
            value: "attachment",
            payload: "attachment",
            command: () => navigate("attachment"),
          },
          {
            label: "Salary",
            value: "salary",
            payload: "salary",
            command: () => navigate("salary"),
          },
          {
            label: "Government Fees",
            value: "government",
            payload: "government",
            command: () => navigate("government"),
          },
        ],
      },
      {
        label: "Schedule",
        items: getScheduleChildItems(),
      },
      {
        label: "Behaviour",
        items: [
          {
            label: "Score",
            value: "score",
            payload: "score",
            command: () => navigate("score"),
            data: {
              isHidden: !appFeature.features.employee.item.score,
            },
          },
          {
            label: "Disciplinary",
            value: "disciplinary",
            payload: "disciplinary",
            command: () => navigate("disciplinary"),
            data: {
              isHidden: !appFeature.features.employee.item.disciplinary,
            },
          },
        ],
        data: {
          isHidden: !appFeature.features.employee.item.behaviour,
        },
      },
      {
        label: "Monetary",
        items: [
          {
            label: "Loan",
            value: "loan",
            payload: "loan",
            command: () => navigate("loan"),
          },
          {
            label: "Loan Payment",
            value: "payment",
            payload: "payment",
            command: () => navigate("payment"),
          },
          {
            label: "Incentives",
            value: "incentive",
            payload: "incentive",
            command: () => navigate("incentive"),
          },
          {
            label: "Overage",
            value: "overage",
            payload: "overage",
            command: () => navigate("overage"),
          },
          {
            label: "Incident",
            value: "employee-incident",
            payload: "employee-incident",
            command: () => navigate("incident"),
          },
          {
            label: "Incident Deduction",
            value: "employee-deduction",
            payload: "employee-deduction",
            command: () => navigate("deduction"),
          },
          {
            label: "Penalty",
            value: "penalty",
            payload: "penalty",
            command: () => navigate("penalty"),
          },
        ],
        data: {
          isHidden: !appFeature.features.employee.item.monetary,
        },
      },
      {
        label: "Others",
        items: [
          {
            label: "Timeline",
            value: "timeline",
            payload: "timeline",
            command: () => navigate("timeline"),
          },
        ],
      },
    ];
    menu.push(...otherMenu);

    const filteredMenu = getVisibleMenu(menu);
    return filteredMenu;
  }, []);

  return { menu: getMenu() };
}
